import { TASK_MANAGEMENT_PILLAR_KEY } from 'constants/general';
import { USER_PILLAR_ACCESS_TYPES } from 'constants/interfaces';

import type IUser from 'store/slices/user/interfaces/IUser';
import type IAccessTaskUser from './interfaces/IAccessTaskUser';

export default function getAccessTaskManagement(user: IUser) {
  const userInfo: IAccessTaskUser = {
    id: user?.id,
    role: user?.role,
    permissionTaskManagement: user?.permissions?.pillarModules.find(
      (item) => item.key === TASK_MANAGEMENT_PILLAR_KEY as string,
    )?.access ?? USER_PILLAR_ACCESS_TYPES.noAccess,
  };
  return userInfo;
}
